<template>
	<div class="feedback-content">
		<div class="ss-container" v-show="finish">
			<div class="feedback-title">意见反馈</div>
			<div class="feedback-input-box">
				<div v-for="(item, index) in formELe" :key="index">
					<div class="feedback-input-title">{{item.itemLabel}}</div>
					<textarea :ref="item.field" maxlength="500" v-if="item.dataType === 'textarea'" @input="inputChange($event, item.field)" class="feedback-input" :placeholder="item.placeholder"></textarea>
					<input :ref="item.field" v-else class="feedback-input" @input="inputChange($event, item.field)" :placeholder="item.placeholder" />
				</div>
				<!-- <div class="feedback-input-title">验证码</div> -->
				<!-- <input class="feedback-input" placeholder="输入图形验证码" /> -->
				<!-- <div class="clearfix yzm-row">
					<img src="~@/assets/img/culturalActivity/wdbm.png" class="feedback-image" />
					<div class="feedback-text">
						看不清？<span>换一张</span>
					</div>
				</div> -->
				<button class="submit-btn btn-primary" @click="smartForm">提交反馈</button>


				<router-link class="submit-btn btn-default btn-sm" style="width: 200px"  :to="{path: '/'}">返回首页</router-link>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				formELe: [],
				formData: {},
				finish: false
			}
		},
		computed: {
			textareaLen_() {
				return (field) => {
					let val = this.formData[field] || '';
					return val.length
				}
			},
			disabled_() {
				let isAnswerArr = this.formELe.filter(o => o.isRequired).map(o => o.field);
				let disabled = false;
				for(var i in isAnswerArr){
					let item = this.formData[isAnswerArr[i]];
					if(!(this.$typeof(item) === 'Array' ? item.length : item)){
						disabled = true;
						break;
					}
				}
				return disabled;
			}
		},
		created() {
			this.feedbackForm();
		},
		methods: {
			inputChange(e, field){
				this.$set(this.formData, field, this.$refs[field][0].value);
			},
			localIndex(e, field){

			},
			async feedbackForm() {
				let res = await this.$http('feedbackForm');
				if(res.code === 1){
					this.finish = true;
					this.formELe = res.data || [];
				}
			},
			async smartForm() {
				if(this.disabled_){
					let isAnswerArr = this.formELe.filter(o => o.isRequired);
					for(var i in isAnswerArr){
						let item = isAnswerArr[i]
						if(!this.formData[item.field]){
							this.$toast('请输入' + item.placeholder);
							break;
						}
					}
					return ;
				}
				let res = await this.$http('smartForm', {
					...this.formData,
					formId: this.formELe[0].formId
				});
				console.log("提交反馈",res);
				if(res.code === 1){
					// this.$toast(res.data.message);
					this.$toast("已提交，感谢您的反馈");
					this.formData = {}
					let formELe = this.$deepClone(this.formELe);
					this.formELe = [];
					this.$nextTick(() => {
						setTimeout(() => {
							this.formELe = formELe;
						}, 10)
					})
				}
			}
		}
	}
</script>

<style lang="scss">
	@import '@/assets/css/feedback.scss';
</style>
